import { render, staticRenderFns } from "./EntregaCancelamento.vue?vue&type=template&id=4df7bff4"
import script from "./EntregaCancelamento.vue?vue&type=script&lang=js"
export * from "./EntregaCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports